import axios from "axios";
import React, { useEffect } from "react";
import GetServerAddress from "../../../../functions/GetServerAddress";

export function Search_Hubspot_Company_By_Name(
  FindHubspotCompany,
  setReturnedHubspotCompany,
  logoutStudent
) {
  const fetchData = async () => {
    try {
      const response = await axios.post(
        GetServerAddress() + "api/staff/Search_Hubspot_Company_By_Name",
        {
          FindHubspotCompany: FindHubspotCompany,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Token")}`, // Include the JWT token in the request headers
            username: localStorage.getItem("Username"),
            activitylog: "No",
          },
        }
      );
      // Check for specific server response indicating an invalid auth token
      if (response.data.status === 403 || response.data.status === 401) {
        logoutStudent();
        return; // Stop further execution in case of invalid auth token
      }
      console.log("Response Data: ", response);
      setReturnedHubspotCompany(response.data.data); // Update your state with the fetched data
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  fetchData();
} // Empty dependency array means this effect runs only once
